import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class CartTabs extends HTMLElement {
  #tabs = [...this.querySelectorAll('[role="tab"]')];
  #drawer = this.closest('drawer-element');
  #title = this.#drawer?.querySelector('[data-cart-tabs-title]');
  #panels = this.#drawer ? [...this.#drawer.querySelectorAll('[data-cart-tabs-panel]')] : [];
  #footer = this.#drawer?.querySelector('[data-cart-tabs-footer]');
  #wishlistCount = this.querySelector('[data-wishlist-count]');
  #cartTab = this.querySelector('[data-cart-tabs-tab="cart"]');
  #count = 0;
  #abortController;
  #unsubscribeWishlistCount;
  #unsubscribeCartAdd;

  connectedCallback() {
    this.#unsubscribeWishlistCount = Pubsub.subscribe('wishlist:count', ({ data }) => {
      this.hidden = false;
      this.#count = data.count;
      if (this.#wishlistCount) this.#wishlistCount.textContent = data.count;
    });

    this.#unsubscribeCartAdd = Pubsub.subscribe('cart:add', () => {
      if (this.#count === 0 && this.#cartTab) this.#selectTab(this.#cartTab);
    });

    if (this.#tabs.length === 0) return;

    this.#abortController = new AbortController();
    this.#tabs.forEach((tab) => {
      tab.addEventListener('click', this.#onTabClick, { signal: this.#abortController.signal });
      tab.addEventListener('keydown', this.#onTabKeydown, { signal: this.#abortController.signal });
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#unsubscribeWishlistCount?.();
    this.#unsubscribeCartAdd?.();
  }

  #onTabClick = (event) => this.#selectTab(event.currentTarget);

  #onTabKeydown = (event) => {
    const currentIndex = this.#tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    const keyToIndex = {
      ArrowLeft: currentIndex - 1,
      ArrowRight: currentIndex + 1,
      Home: 0,
      End: this.#tabs.length - 1,
    };
    const nextIndex = keyToIndex[event.key];
    if (nextIndex === undefined) return;

    event.preventDefault();
    const nextTab = this.#tabs.at((nextIndex + this.#tabs.length) % this.#tabs.length);
    this.#selectTab(nextTab);
    nextTab.focus();
  };

  #selectTab(selectedTab) {
    const selectedPanel = selectedTab.dataset.cartTabsTab;
    if (!selectedPanel) return;

    this.#tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle('button--black', isSelected);
      tab.classList.toggle('button--gray', !isSelected);
      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
    });

    this.#panels.forEach((panel) => {
      panel.hidden = panel.dataset.cartTabsPanel !== selectedPanel;
    });
    this.#footer?.toggleAttribute('hidden', selectedPanel !== 'cart');

    if (this.#title) {
      this.#title.textContent =
        selectedPanel === 'cart' ? this.dataset.cartTitle : this.dataset.wishlistTitle;
    }

    Pubsub.publish('cart:tab', { data: { tab: selectedPanel } });
  }
}

customElements.define('cart-tabs', CartTabs);
